module.exports = __webpack_public_path__ + "media/images/icons/apple-touch-icon-df6e04e9982feb5d145d8982bb9d0b9d.png";